import axios from 'axios';
import { DB_URL } from '../../util/DB_URL';
import qs from 'qs';

export const GET_CUSTOMERS = 'GET_CUSTOMERS';

export function getCustomers(cookie) {
  const query = qs.stringify(
    {
      fields: ['id', 'name'],
      populate: ['billing', 'shipping', 'paymentMethods'],
    },
    {
      encodeValuesOnly: true,
    }
  );

  return async function (dispatch) {
    const data = await axios.get(`${DB_URL}/api/customers?${query}`, {
      //   headers: {
      //     Authorization: `Bearer ${cookie}`,
      //   },
    });

    return dispatch({
      type: GET_CUSTOMERS,
      data: data.data,
    });
  };
}
